import React, { Component } from "react";
import { connect } from "react-redux";
import Drawer from "@material-ui/core/Drawer";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { Button } from "@material-ui/core";
import NutritionalFacts from "./NutritionalFacts";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
import "./Summary.css";

export class Summary extends Component {
  state = {
    isMobile: false,
  };

  toggleDrawer = () => {
    window.scrollBy(0, 5);
    window.scrollBy(0, -5);
  };

  render() {
    const language = this.props.language;

    const {
      selectedProduct,
      showNutrition,
      nutritionalFacts,
      current_product,
      settings,
    } = this.props;

    const products = (this.props.store?.categories || []).flatMap(category => category.products || []);
    const store_product = products.flatMap(product => [product, ...(product.children || [])])
      .find(product => String(product.id) === String(current_product.id));
    // Direct links and search may hydrate the detail before the menu cache.
    const optionCatalog = current_product.options?.length ? current_product.options : store_product?.options || [];

    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const options = [];
    for (const group in this.props.current_item.options) {
      const OptionGroup = optionCatalog.find(
        (optionGroup) => String(optionGroup.id) === String(parseInt(group, 10))
      );

      options.push(
        Object.keys(this.props.current_item.options[group].selectedOptions || {}).map(
          (key) => {
            const selected = this.props.current_item.options[group].selectedOptions[key];
            const choice = OptionGroup?.choices?.find((option) => option.id == key) || selected;
            const label = (language === "arabic" && choice.ar_value) || choice.value;
            if (!label) return null;
            return (
              <span key={`${group}-${key}`} className="sf-product-summary__option">
                <bdi>{label}</bdi><bdi className="sf-product-summary__quantity" dir="ltr">× {selected.quantity}</bdi>
              </span>
            );
          }
        )
      );
    }
    const currencyIcon = getCurrencyIcon(settings)

    return (
      <>
        <div className="mb-5 w-100 ">
          <Drawer
            className="h-100"
            anchor="bottom"
            PaperProps={{
              className: "sf-product-summary-paper",
              dir: language === "arabic" ? "rtl" : "ltr",
              role: "dialog",
              "aria-modal": true,
              "aria-labelledby": "sf-product-summary-title",
            }}
            open={this.props.visible}
            onClose={() => this.props.onClose()}
          >
            <div
              className="sf-product-summary"
              style={{
                backgroundColor: "white",
                overflowX: "hidden",
              }}
            >
              <div
                className="sf-product-summary__header"
              >
                <h2 id="sf-product-summary-title">{`${
                  language === "english" ? "Summary" : "الملخص"
                }`}</h2>
                <div>
                  <IconButton
                    aria-label={language === "arabic" ? "إغلاق الملخص" : "Close summary"}
                    onClick={() => this.props.onClose()}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
              <div>
                <div
                  className="sf-product-summary__row"
                >
                  <span className="sf-product-summary__name">
                    {language === "english"
                      ? this.props.current_item.name
                      : this.props.current_item.ar_name || this.props.current_item.name}{" "}
                    <bdi className="sf-product-summary__quantity" dir="ltr">
                      × {this.props.current_item.quantity}
                    </bdi>{" "}
                  </span>
                  <span
                    className={`sf-product-summary__total ${currencyIcon || ""}`}
                  >
                    <bdi>{language === "english"
                      ? settings.currency_english
                      : settings.currency_local}{" "}
                    {this.props.current_item.total_price.toFixed(
                      settings.currency_decimals
                    )}</bdi>
                  </span>
                </div>
              </div>
              <div
                className="sf-product-summary__options"
              >
                {options}
              </div>

              {showNutrition &&
                settings.show_nutrition_facts &&
                (nutritionalFacts?.totalCalories > 0 ||
                  nutritionalFacts?.totalCarbs > 0 ||
                  nutritionalFacts?.totalProtein > 0 ||
                  nutritionalFacts?.totalFats > 0 ||
                  nutritionalFacts?.isDairyFree ||
                  nutritionalFacts?.isSugarFree ||
                  nutritionalFacts?.isGlutenFree ||
                  nutritionalFacts?.isNutFree ||
                  nutritionalFacts?.isOrganic ||
                  nutritionalFacts?.isVegan ||
                  nutritionalFacts?.isVegetarian ||
                  nutritionalFacts?.containsGluten ||
                  nutritionalFacts?.containsNutsSesame ||
                  nutritionalFacts?.containsDairy ||
                  nutritionalFacts?.containsEgg ||
                  nutritionalFacts?.containsSeafoodShellfish ||
                  nutritionalFacts?.containsChilli) && (
                  <div>
                    <NutritionalFacts
                      nutritionalFacts={nutritionalFacts}
                      fromPage={"product"}
                    />
                  </div>
                )}

              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 5,
                }}
              >
                <Button
                  className="sf-product-summary__close"
                  fullWidth
                  onClick={() => this.props.onClose()}
                >{`${language === "english" ? "Close" : "إغلاق"}`}</Button>
              </div>
            </div>
          </Drawer>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    cart_items: state.cart.cart,
    settings: state.store.store.settings,
    store: state.store.store,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
